export default "__VITE_ASSET__DI7wuyGk__"